import React, { useState, useRef, useEffect } from 'react'
import styles from "./StoreCatalogCard.module.css"
import { GoImage } from "react-icons/go";
import { BsThreeDotsVertical } from "react-icons/bs";
import { responsiveMedia } from "../../services/media";

export default function StoreCatalogCard(
    {
        name,
        description,
        image,
        variantCount,
        activeVariantCount,
        pricing,
        onClick = () => {},
        onRename = () => {},
        onDelete = () => {},
        type = "product",
        variantMetadata = {},
        showMenu = true,
    }
) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    function handleMenuToggle(event) {
        event.stopPropagation();
        setMenuOpen((prev) => !prev);
    }

    function handleMenuAction(action) {
        return (event) => {
            event.stopPropagation();
            setMenuOpen(false);
            action();
        };
    }

    function formatVariantCount(variantCount, activeVariantCount) {
        if (activeVariantCount === variantCount) {
            return `${variantCount} variants`;
        }
        return `${activeVariantCount} / ${variantCount} active variants`;
    }
    const isDraftCard = variantCount === 0;
    return (
        <div
            className={styles.cardContainer}
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onClick();
                }
            }}
        >
            <div className={styles.cardImageContainer}>
                {showMenu && (
                    <div className={styles.cardMenuContainer} ref={menuRef}>
                        <button
                            type="button"
                            className={styles.cardMenuButton}
                            onClick={handleMenuToggle}
                            aria-label="Card options"
                        >
                            <BsThreeDotsVertical size={16} />
                        </button>
                        {menuOpen && (
                            <div className={styles.cardMenuDropdown}>
                                <button
                                    type="button"
                                    className={styles.cardMenuOption}
                                    onClick={handleMenuAction(onRename)}
                                >
                                    Rename
                                </button>
                                <button
                                    type="button"
                                    className={`${styles.cardMenuOption} ${styles.cardMenuOptionDanger}`}
                                    onClick={handleMenuAction(onDelete)}
                                >
                                    Delete
                                </button>
                            </div>
                        )}
                    </div>
                )}
                {image?.url ? (
                    <img {...responsiveMedia(image.url, "(max-width: 600px) 90vw, 320px")} loading="lazy" decoding="async" className={styles.cardImage} alt={image.alt_text || name} />
                ) : (
                    <GoImage className={styles.cardImagePlaceholder} />
                )}
                <div className={styles.cardPriceContainer}>
                    {isDraftCard? 
                    <p className={styles.cardPrice}>Draft</p>
                    : 
                    <p className={styles.cardPrice}>{pricing?.display || "Price unavailable"}</p>}
                    
                </div>
                
            </div>
            {type === "product" && (
                <div className={`${styles.cardContentContainer} ${isDraftCard ? styles.draftCard : ""}`}>
                <h2 className={styles.cardTitle}>{name}</h2>
                <p className={styles.cardDescription}>{description}</p>
                <p className={styles.cardVariantCount}>{formatVariantCount(variantCount, activeVariantCount)}</p>
                </div>
                
            )} 
            
            
            {type === "variant" &&(
                <div className={`${styles.cardContentContainer} ${isDraftCard ? styles.draftCard : ""}`}>
                    <h2 className={styles.cardTitle}>{name}</h2>
                    {variantMetadata && Object.keys(variantMetadata).length > 0 && Object.entries(variantMetadata).map(([key, value]) => (
                            <p key={key} className={styles.cardDescription}>
                                <strong>{key}:</strong> {typeof value === "object" && value !== null
                                    ? (value.display || value.value || value.quantity || JSON.stringify(value))
                                    : value}
                                    
                            </p>
                            
                    
                    ))}
                    
                </div>
                
            )}
            
        </div>
    )
}
